// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plain-tooltip[data-v-3318d168] {\n  position: absolute;\n  border: 1px solid var(--black);\n  overflow: hidden;\n  pointer-events: none;\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n.plain-tooltip.ag-tooltip-hiding[data-v-3318d168] {\n  opacity: 0;\n}\n.plain-tooltip p[data-v-3318d168] {\n  margin: 5px;\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
